import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import I18n from 'i18n/en-US';
import React from 'react';

import classes from './ItemsPagination.style';

interface ComponentProps {
  activeItem: string;
  items: string[];
  onItemChange: (item: string) => void;
}

function ItemsPagination({
  activeItem, items, onItemChange,
}: ComponentProps) {
  const itemIndex = (item: string) => items.findIndex((i) => i === item);

  const handleFirstPageButtonClick = () => {
    onItemChange(items[0]);
  };

  const handleBackButtonClick = () => {
    onItemChange(items[itemIndex(activeItem) - 1]);
  };

  const handleNextButtonClick = () => {
    onItemChange(items[itemIndex(activeItem) + 1]);
  };

  const handleLastPageButtonClick = () => {
    onItemChange(items[items.length - 1]);
  };

  return (
    <Box sx={classes.actions}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={itemIndex(activeItem) === 0}
        aria-label={I18n.Elements.ItemsPagination.first}
        sx={classes.button}
        size="large"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={!items[itemIndex(activeItem) - 1]}
        aria-label={I18n.Elements.ItemsPagination.previous}
        sx={classes.button}
        size="large"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <Typography
        component="span"
        sx={classes.item}
      >
        {itemIndex(activeItem) + 1}
      </Typography>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={!items[itemIndex(activeItem) + 1]}
        aria-label={I18n.Elements.ItemsPagination.next}
        sx={classes.button}
        size="large"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={itemIndex(activeItem) === items.length - 1}
        aria-label={I18n.Elements.ItemsPagination.last}
        sx={classes.button}
        size="large"
      >
        <LastPageIcon />
      </IconButton>
    </Box>
  );
}

export default ItemsPagination;
